import { useParams } from 'react-router-dom';
import { useStore } from '../../app/stores/store';
import { useEffect,  useState } from 'react';
import agent from '../../app/api/agent';
import { Menu } from 'semantic-ui-react';
import SmartTrackerReports from '../SmartTracker/SmartTrackerReports';
import { observer } from 'mobx-react-lite';
import './styles.css';
import UnauthorizedMessage from '../UnauthorizedMessage';
import LoadingComponent from '../../app/layout/LoadingComponent';
import ReelSmarttracker from '../SmartTracker/ReelSmarttracker';

function SmartFlow() {
  const ids = useParams();
  const { templateId } = ids as any;

  const { TrackingReportStore, reportStore, commonStore, dashboardStore,userStore } =
    useStore();

  const { metaDataPaginationAll } = reportStore;

  const [taskDetails, setTaskDetails] = useState<
    {
      task: string;
      count: number;
    }[]
  >([]);
  const [subTaskDetails, setSubTaskDetails] = useState<
    {
      subtask: string;
      count: number;
    }[]
  >([]);
  const [selectedItems, setSelectedItems] = useState<{
    task: string;
    subtask: string;
  }>({
    task: '',
    subtask: '',
  });

    //State

    const [currentTitle_Code, setCurrentTitle_Code] = useState<{
      value: string;
      list: {
        key: string;
        value: string;
        text: string;
      }[];
    }>({
      value: '',
      list: [],
    });
    const [currentPl_id, setCurrentPl_id] = useState<{
      value: string;
      list: {
        key: string;
        value: string;
        text: string;
      }[];
    }>({
      value: '',
      list: [],
    });
    const [currentDisplayName, setCurrentDisplayName] = useState<{
      value: string;
      list: {
        key: string;
        value: string;
        text: string;
      }[];
    }>({
      value: '',
      list: [],
    });

const [loadingComponent,setLoadingComponent] = useState(false)
useEffect(()=>{
  if(commonStore.RestorationCustomer){
    // defect table dropdown
    TrackingReportStore.bindTableDropdown();
  }
      // eslint-disable-next-line
},[])

  useEffect(() => {
    return () => {
      TrackingReportStore.productionPlanning = {
        ...TrackingReportStore.productionPlanning,
        isFromPP: false,
        task: '',
        subtask: '',
        taskList: [],
        subtaskList: [],
      };
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setTaskDetails([]);
    setSubTaskDetails([]);
    TrackingReportStore.productionPlanning.task = '';
    TrackingReportStore.productionPlanning.subtask = '';
    TrackingReportStore.productionPlanning.isFromPP = false;
    // eslint-disable-next-line
  }, [templateId]);

  // useEffect(() => {
  //   (async () => {
  //     setLoadingComponent(true);
  //     let result = await agent.ProdPlanning.listProductionPlanningTemplate({
  //       templateId,
  //     }); 
  //     if (result.data?.length > 0) {
  //       setTaskDetails(result.data);
  //       clickTaskHandler(result.data[0].task || '', result.data,false,false);
  //     }
  //   })();
  //   // eslint-disable-next-line
  // }, [templateId]);

  useEffect(() => {
    (async () => {
      setLoadingComponent(true);
      let result = [
        {task : 'Restoration', count: 0},
      ]
      setTaskDetails(result);
      clickTaskHandler(result[0].task || '', [],false,false);
    })();
  // eslint-disable-next-line
  }, [templateId]);

  const roleHandler = ()=>{
    const defaultSubtaskList = [
      'Full Restoration',
      'Quality Check',
      'Final Quality Analysis',
      'Client Quality Check',
      'Wave Production',
      'CC Form Production',
      'QT Processes'
    ];
    //------------ Color Restoration ------------------ ///
    const colorationAdmin=['Poly Creation','Colorization','QC'];
        const roleToTempListMapping: Record<string, string[]> = {
      Operator: ['Full Restoration'],
      'Quality Check': ['Full Restoration','Quality Check', 'Final Quality Analysis', 'Client Quality Check', 'Wave Production', 'CC Form Production','QT Processes'],
      'Client QC': ['Full Restoration','Quality Check', 'Final Quality Analysis', 'Client Quality Check', 'Wave Production', 'CC Form Production','QT Processes'],
      'Process Lead': ['Full Restoration', 'Quality Check'],
      'Process Specialist': ['Full Restoration'],
      'Resto Admin': defaultSubtaskList,
      //------------ Color Restoration ------------------ ///
      'Restoration Admin':colorationAdmin,
      'Colorization':['Poly Creation','Colorization'],
      'ProcessLead':['Poly Creation','Colorization'],
      'QC':['QC'],
    };

    const userRole = userStore.user?.roleName || '';
    const tempList = roleToTempListMapping[userRole] || defaultSubtaskList;
    return tempList;
  }

    const handleSubtask = async ()=>{
      const params = {
        templateId,
        currentTask: 'Restoration',
      };
      setSelectedItems({
        task: 'Restoration',
        subtask: '',
      });
    const result = await agent.ProdPlanning.listProductionTaskTemplate(params);
    const tempList = roleHandler();
    const newCurrSubtask = tempList.map(subtask => {
      const found = result.data.find((item: any) => item.subtask === subtask);
      return found ? { subtask: found.subtask, count: found.count } : { subtask, count: 0 };
    });
    setSubTaskDetails(newCurrSubtask);
  let selectedSubtask = '';
  newCurrSubtask.forEach((element: any) => {
    if (selectedItems.subtask === element.subtask && element.count !== 0) {
      selectedSubtask = element.subtask;
    }
  })
  let dropdown: boolean = false;
  if (selectedSubtask !== selectedItems.subtask) {
    dropdown = true;
    setCurrentTitle_Code({ ...currentTitle_Code, value: '' });
    setCurrentPl_id({ ...currentPl_id, value: '' });
    setCurrentDisplayName({ ...currentDisplayName, value: '' });
  }
  
  setSelectedItems({
    task: 'Restoration',
    subtask: selectedSubtask || newCurrSubtask.find(subtask => subtask.count > 0)?.subtask,
  });
  
  getNewDetails(1, undefined, dropdown);
   TrackingReportStore.productionPlanning.dropdownChanges = false; 
    }
  useEffect(()=>{
    if(TrackingReportStore.productionPlanning.dropdownChanges && commonStore.RestorationCustomer){
      handleSubtask();
    }
    // eslint-disable-next-line
  },[TrackingReportStore.productionPlanning.dropdownChanges])

  useEffect(() => {
    if (selectedItems.task && selectedItems.subtask) {
      TrackingReportStore.productionPlanning = {
        ...TrackingReportStore.productionPlanning,
        isFromPP: true,
        task: selectedItems.task,
        subtask: selectedItems.subtask,
      };
    } else {
      TrackingReportStore.productionPlanning.task = '';
      TrackingReportStore.productionPlanning.subtask = '';
      TrackingReportStore.productionPlanning.isFromPP = false;
    }
    // eslint-disable-next-line
  }, [selectedItems]);

  useEffect(() => {
    let taskFilter = taskDetails.filter((d) => d.task === selectedItems.task);
    let subtTaskFilter = subTaskDetails.filter(
      (d) => d.subtask === selectedItems.subtask,
    );
    if (
      metaDataPaginationAll.length === 0 &&
      taskFilter.length === 0 &&
      subtTaskFilter.length === 0 &&
      taskDetails.length &&
      subTaskDetails.length
    ) {
      let task = taskDetails[0]?.task;
      let subtask = subTaskDetails[0]?.subtask;

      setSelectedItems({
        task: taskDetails[0].task,
        subtask: subTaskDetails[0].subtask,
      });
      TrackingReportStore.productionPlanning = {
        ...TrackingReportStore.productionPlanning,
        isFromPP: true,
        task: task || '',
        subtask: subtask || '',
      };
    }
    // eslint-disable-next-line
  }, [JSON.stringify(metaDataPaginationAll)]);


    const   getNewDetails = (pageNumber?: number, subtask?: string,dropdown?:boolean) => {
    TrackingReportStore.bindComponent.model = false;
    TrackingReportStore.ActiveRowId=''
    const titles = (localStorage.getItem('SmartTracker') || '').split(',').concat('id');
    const searchData: Record<string, string> = {
      ...dashboardStore.dashboard.searchfilterparams,
      current_task: selectedItems.task || '',
      current_subtask: selectedItems.subtask ? (subtask || selectedItems.subtask) : '',
      'metadata/ title_code': dropdown === true ? '' : currentTitle_Code.value || '',
      'metadata/ pl_name': dropdown === true ? '' :   currentPl_id.value || '',
      'metadata/ displayname': dropdown === true ? '' :  currentDisplayName.value || '',
    };
    if (!selectedItems.subtask && !selectedItems.task) return;
  
    if (selectedItems.subtask && selectedItems.task) {
      reportStore.searchMetaDataReport(
        pageNumber || 1,
        searchData,
        titles,
        commonStore.RestorationCustomer ? 'SmartTracker' : '',
      );
    }
  };
  

  const clickTaskHandler = async (name: string, tasks: string[] = [], iscomplete: boolean = false,notChangeSubtsk:boolean) => {
    iscomplete && setLoadingComponent(iscomplete);
    const params = {
      templateId,
      currentTask: name || 'Restoration',
    };
    setSelectedItems({
      task: name || selectedItems.task || '',
      subtask: '',
    });
  
    const result = await agent.ProdPlanning.listProductionTaskTemplate(params);
    if(commonStore.RestorationCustomer){
    if (result.data?.length) {
      const tempList = roleHandler();
      const newCurrSubtask = tempList.map(subtask => {
        const found = result.data.find((item: any) => item.subtask === subtask);
        return found ? { subtask: found.subtask, count: found.count } : { subtask, count: 0 };
      });
      const selectedSubtask = newCurrSubtask.find(subtask => subtask.count > 0)?.subtask || '';
      setSubTaskDetails(newCurrSubtask);
  
      if(notChangeSubtsk){
        const filteredSubtasks = newCurrSubtask.filter(item => item.subtask === selectedItems.subtask && item.count !== 0);
        let selectedSubtaskFiltered = '';
        if (filteredSubtasks.length > 0) {
            selectedSubtaskFiltered = filteredSubtasks[0].subtask;
        } else {
          const selectedSubtask = newCurrSubtask.find(subtask => subtask.count > 0)?.subtask || '';
          selectedSubtaskFiltered = selectedSubtask[0]?.subtask
        }
        setSelectedItems({
            task: name || selectedItems.task || '',
            subtask: selectedSubtaskFiltered
        });
        
        TrackingReportStore.productionPlanning = {
          ...TrackingReportStore.productionPlanning,
          isFromPP: true,
          taskList: tasks.map((d: any) => ({ key: d.task, value: d.task, text: d.task })),
          subtaskList: newCurrSubtask.map((d: any) => ({ key: d.subtask, value: d.subtask, text: d.subtask })),
        };
        getNewDetails(1);
        dashboardStore.setReportsPageNum(1);
      }else{
        setSelectedItems({
          task: name || selectedItems.task || '',
          subtask: selectedSubtask || selectedItems.subtask || '',
        });
        TrackingReportStore.productionPlanning = {
          ...TrackingReportStore.productionPlanning,
          isFromPP: true,
          task: name || selectedItems.task || '',
          subtask: selectedSubtask || selectedItems.subtask || '',
          taskList: tasks.map((d: any) => ({ key: d.task, value: d.task, text: d.task })),
          subtaskList: newCurrSubtask.map((d: any) => ({ key: d.subtask, value: d.subtask, text: d.subtask })),
        };
      }
    }
  } else {
      setSubTaskDetails(result.data);
      setSelectedItems({
        task: name || selectedItems.task || '',
        subtask: result.data[0]?.subtask || selectedItems.subtask || '',
      });
  
      if (result.data[0]?.count === 0) {
        setSelectedItems(prevState => ({ ...prevState, subtask: result.data[0]?.subtask || '' }));
      }
  
      TrackingReportStore.productionPlanning = {
        ...TrackingReportStore.productionPlanning,
        isFromPP: true,
        task: name || selectedItems.task || '',
        subtask: selectedItems.subtask || result.data[0]?.subtask || '',
        taskList: tasks.map((d: any) => ({ key: d.task, value: d.task, text: d.task })),
        subtaskList: result.data.map((d: any) => ({ key: d.subtask, value: d.subtask, text: d.subtask })),
      };
    }
  
    setLoadingComponent(false);
  };
  

  const subTaskClickHandler = (name: string) => {
    setCurrentTitle_Code({
      ...currentTitle_Code,
        value:'',
    })
    setCurrentPl_id({
      ...currentPl_id,
      value:''
    })
    setCurrentDisplayName({
      ...currentDisplayName,
      value:''
    })
    setSelectedItems({
      ...selectedItems,
      task: selectedItems.task || 'Restoration',
      subtask: name || '',
    });
    TrackingReportStore.statusButtonShow('');
    if(['Wave Production','CC Form Production','QT Processes'].includes(name)){
      TrackingReportStore.reelSmartrackerSearchShow('',name);
     TrackingReportStore.reelSmarttracker.selectedSubtask = name || '';
     TrackingReportStore.reelSmarttracker.isModel = false;
     TrackingReportStore.reelSmarttracker.tableData = [];
     TrackingReportStore.reelSmarttracker.count = 0;
     TrackingReportStore.reelSmarttracker.loader = false;
     TrackingReportStore.titleCode.value = '';
    }
  };

  return (
    <>
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <div style={{ marginTop: '30px' }}>
          <LoadingComponent />
        </div>
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' && !commonStore.RestorationCustomer && 
        !commonStore.filterModeOne?.includes('SMF01') && (
          <UnauthorizedMessage />
        )}
      <div style={{ padding: '0px 20px' }}>
        <div className="newProductionPlanning-wrapper">
          <div>
          {commonStore.RestorationCustomer ? <></> : <Menu
              style={{
                padding: '5px', height: '47px'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '10px',
                  flexWrap: 'wrap',
                }}
              >
                {!taskDetails?.length ? (
                  <h4>Sorry No Data</h4>
                ) : (
                  taskDetails.map(({ task, count }) => (
                    <button
                    style={{height:'10px'}}
                      className={
                        count === 0
                          ? 'disabled'
                          : selectedItems.task === task
                            ? 'selected'
                            : ''
                      }
                      onClick={() => clickTaskHandler('TaskName', undefined, true,false)}
                      disabled={count === 0}
                    >{`${task} (${count})`}</button>
                  ))
                )}
              </div>
            </Menu>}
            {!(
              subTaskDetails?.length === 1 &&
              subTaskDetails[0].subtask === selectedItems.task
            ) && (
              <Menu
              style={{
                padding: '5px', height: '47px'
              }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px',
                    flexWrap: 'wrap',
                  }}
                >
                  {!subTaskDetails?.length ? (
                    <h4>Sorry No Data</h4>
                  ) : ( subTaskDetails.map(({ subtask, count }) => {
                      const validSubtasks = ['Wave Production', 'CC Form Production', 'QT Processes'];
                      const isValidSubtask = validSubtasks.includes(subtask);
                      const isDisabled = !isValidSubtask && count === 0;
                      const buttonClass = selectedItems.subtask === subtask ? 'selected' : (isDisabled ? 'disabled' : '');
                    
                      return (
                        <button
                          key={subtask} // Ensure a unique key if subtask names are not unique
                          style={{ height: '10px' }}
                          onClick={() => subTaskClickHandler(subtask)}
                          className={buttonClass}
                          disabled={isDisabled}
                        >
                          {`${subtask} ${isValidSubtask ? '' : `(${count})`}`}
                        </button>
                      );
                    })
                  )}
                </div>
              </Menu>
            )}
           {loadingComponent  && <LoadingComponent/>}
            {TrackingReportStore.productionPlanning.task &&
              TrackingReportStore.productionPlanning.subtask &&
              TrackingReportStore.productionPlanning.isFromPP && (
                <>
                {['Wave Production','CC Form Production','QT Processes'].includes(selectedItems.subtask) ? <ReelSmarttracker/> : 
                <SmartTrackerReports 
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                clickTaskHandler={clickTaskHandler}
                currentTitle_Code={currentTitle_Code}
                setCurrentTitle_Code={setCurrentTitle_Code}
                currentPl_id={currentPl_id}
                setCurrentPl_id={setCurrentPl_id}
                currentDisplayName={currentDisplayName}
                setCurrentDisplayName={setCurrentDisplayName}
                getNewDetails={getNewDetails}
                />
                }
                </>
              )}
          </div>
        </div>
      </div>
    </>
  );
}

export default observer(SmartFlow);
